const plugin = require('tailwindcss/plugin');

const flexCenterUtils = plugin(function ({addUtilities}) {
  addUtilities({
    '.flex-center': {
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
    },
    '.flex-center-full': {
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      'flex-direction': 'column',
      'min-width': '100%',
      height: '100%',
      flex: '1 1 0%',
    },
    '.flex-center-full-auto': {
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      'flex-direction': 'column',
      'min-width': '100%',
      height: 'auto',
      flex: '1 1 0%',
    },
    '.flex-center-full-grow': {
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      'flex-direction': 'column',
      width: '100%',
      height: '100%',
      grow: 1,
    },
    '.flex-center-col': {
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      'flex-direction': 'column',
    },
  });
});

module.exports = flexCenterUtils;
